import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { includes as _includes } from 'lodash';

import {
    bookingStatusToCssClass,
    getStartEndTimesBasedOnBookingStatus,
    getBookingPlant
} from '../../util/bookingHelpers';

import './BookingCalendarEntry.css';

export default class BookingCalendarEntry extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        booking: PropTypes.object.isRequired,
        plant: PropTypes.object.isRequired,
        persons: PropTypes.object.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        browserHistory.push(`/bookings/${this.props.booking.staticUId}`);
    }

    render() {
        const { booking, plant, user } = this.props;

        const mainPlant = getBookingPlant(booking, plant);
        if (!mainPlant)
            return null;

        const bookingTimes = getStartEndTimesBasedOnBookingStatus(booking);
        const startTime = bookingTimes.start.format(`hh:mm a`);
        const endTime = bookingTimes.end.format(`hh:mm a`);
        const passengerClass = _includes(booking.passengerPersonIds, user.personId) ? `is-passenger` : ``;

        let endJsx = bookingTimes.start.startOf(`d`).isSame(bookingTimes.end.startOf(`d`), `d`)
            ? null
            : <div className="ends-date">Ends on {bookingTimes.end.format(`DD MMM`)}</div>;

        return (
            <div className={`booking-calendar-entry ${passengerClass} ${bookingStatusToCssClass(booking.statusId)}`} onClick={this.handleClick}>
                <div className="status-icon"></div>
                <h2>{mainPlant.name}</h2>
                <div>{startTime} - {endTime}</div>
                {endJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Calendar/BookingCalendarEntry.jsx